import { Component, OnInit } from '@angular/core';
import { HasRolePipe } from '../../../../pipes/has-role.pipe';
import { USER_ROLES } from '../../../../enums';
import { LoadingAndErrors } from '../../../../classes';
import { UserDataApi, PartnerApi } from '../../../../../assets/js/lb-sdk';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent extends LoadingAndErrors implements OnInit {
  merchantDetails;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  user;
  data;

  constructor(
    private hasRole: HasRolePipe,
    public modal: BsModalRef,
    private userDataApi: UserDataApi,
    private partnerApi: PartnerApi
  ) {
    super();
  }

  ngOnInit() {
    this.loading.user = true;
    this.data = this.data || {};
    this.clearErrors();
    this.userDataApi
      .findOne({
        where: { partnerId: this.data.partnerId },
        include: { roles: 'role' }
      })
      .pipe(finalize(() => {
        this.loading.user = false;
      }))
      .subscribe(user => {
        this.user = user;
        if (this.hasRole.transform(this.user.roles, USER_ROLES.GENERAL_MERCHANT, '>=')) {
          this.getMerchantDetails();
        }
      }, error => {
        this.errors.user = 'Failed to load user details';
      });
  }

  getMerchantDetails() {
    this.loading.merchant = true;
    this.clearErrors();
    this.partnerApi
      .findById(this.user.partnerId)
      .pipe(finalize(() => {
        this.loading.merchant = false;
      }))
      .subscribe(
        details => {
          this.merchantDetails = details;
        },
        error => {
          this.errors.merchant = error.message || 'Unable to get merchant details';
        }
      );
  }

  dismiss() {
    this.modal.hide();
  }

  close() {
    this.modal.hide();
  }
}
